"use client";
export const dynamic = "force-dynamic";

import { UserExtended } from "@/types";
import { useAppStore, selectUser } from "@/store/appStore";
import { InvoiceContextPanel } from "./components";
import { BaseHTMLAttributes, FC, useEffect, useState } from "react";
import { FilePicker } from "@/components/sidebar/components/file-picker";
import { Dialog } from "@/components/ui/dialog";
import { ContentHeader } from "../components";
import { Plus } from "lucide-react";
import { Content } from "../components/page/components";
import { List } from "../components";
import dayjs from "dayjs";
import { CurrencyCode } from "@/components/ui";
import clsx from "clsx";

interface InvoicesProps
  extends Pick<BaseHTMLAttributes<HTMLDivElement>, "className"> {}

const Invoices: FC<InvoicesProps> = ({ className }) => {
  const user: UserExtended | null = useAppStore(selectUser);
  const invoices = useAppStore((s) => s.invoices);
  const selectedInvoice = useAppStore((s) => s.selectedInvoice);
  const setSelectedInvoice = useAppStore((s) => s.setSelectedInvoice);
  const fetchInvoices = useAppStore((s) => s.fetchInvoices);
  const uploadInvoice = useAppStore((s) => s.uploadInvoice);
  const [showUpload, setShowUpload] = useState(false);

  useEffect(() => {
    fetchInvoices();
    // Optionally set the first invoice as selected
    // setSelectedInvoice(invoices && invoices[0] ? invoices[0] : undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.selectedReport?.id]);

  return (
    user && (
      <>
        <Content>
          <ContentHeader
            title="Invoices"
            subtitle="75% Matched"
            actions={[
              {
                icon: Plus,
                text: "Add Invoice",
                onClick: () => setShowUpload(true),
              },
            ]}
          />
          <List
            groupBy={(invoice) =>
              invoice.date ? dayjs(invoice.date).format("MMM, D") : "Unknown"
            }
            sortGroupBy={(a, b) =>
              a && b
                ? dayjs(b, "MMMM, D, YYYY").unix() -
                  dayjs(a, "MMMM, D, YYYY").unix()
                : 0
            }
            title={(invoice) => dayjs(invoice.date).format("MMM D")}
            items={invoices.map((invoice: (typeof invoices)[number]) => {
              return {
                label: invoice.seller?.companyName || "N/A",
                description: invoice.invoiceId || "No description",
                amount: invoice.totalAmount,
                currency: invoice.currency as CurrencyCode,
                status: "PENDING",
                isSelected: selectedInvoice?.id === invoice.id,
                onClick: () => setSelectedInvoice(invoice),
                image: {
                  type: "logo",
                  source: invoice.seller.corporateWebsiteURL || undefined,
                  fallback: invoice.seller.companyName
                    ? invoice.seller.companyName.slice(0, 2).toUpperCase()
                    : "N/A",
                },
                date: invoice.issueDate || undefined,
                showDate: false,
              };
            })}
          />
          <Dialog open={showUpload} onOpenChange={setShowUpload}>
            <FilePicker
              uploadPath="/api/upload/invoice"
              // FilePicker does not support onUpload, so handle upload after file selection if needed
            >
              <div style={{ padding: 32 }}>
                <p className="mb-4">Upload Invoice PDF or Image</p>
              </div>
            </FilePicker>
          </Dialog>
        </Content>
        <InvoiceContextPanel />
      </>
    )
  );
};

export { Invoices };
